{
  "appName": "VynaEMR",
  "appTagline": "亚太优先的电子病历系统",
  "developedByLabel": "开发",
  "loading": "加载中...",
  "save": "保存",
  "cancel": "取消",
  "delete": "删除",
  "edit": "编辑",
  "create": "新建",
  "search": "搜索",
  "filter": "筛选",
  "actions": "操作",
  "confirm": "确认",
  "back": "返回",
  "next": "下一步",
  "previous": "上一步",
  "submit": "提交",
  "reset": "重置",
  "close": "关闭",
  "yes": "是",
  "no": "否",
  "ok": "确定",
  "error": "错误",
  "success": "成功",
  "warning": "警告",
  "info": "提示",
  "validation": {
    "required": "此字段为必填项",
    "invalidEmail": "电子邮箱格式不正确",
    "invalidPhone": "电话号码格式不正确",
    "invalidDate": "日期格式不正确",
    "minLength": "最少需要 {{min}} 个字符",
    "maxLength": "最多允许 {{max}} 个字符",
    "passwordMismatch": "两次输入的密码不一致"
  },
  "form": {
    "fieldRequired": "请填写{{field}}",
    "selectOption": "请选择一项",
    "discardConfirm": "放弃未保存的更改？",
    "unsavedChanges": "您有未保存的更改",
    "mustBeNonNegativeInteger": "{{field}}必须为不小于 0 的整数",
    "mustBeNonNegativeNumber": "{{field}}必须为不小于 0 的数字"
  },
  "unsavedChanges": {
    "title": "未保存的更改",
    "body": "您有未保存的更改。确定要离开此页面吗?所做更改将会丢失。",
    "stay": "留在本页",
    "leave": "离开"
  },
  "messages": {
    "saveSuccess": "保存成功",
    "saveError": "保存失败",
    "deleteConfirm": "确定要删除此项吗？",
    "deleteSuccess": "删除成功",
    "deleteError": "删除失败",
    "networkError": "网络错误，请检查网络连接。",
    "serverError": "服务器错误，请稍后重试。",
    "unauthorized": "您无权执行此操作。"
  },
  "dateFormat": {
    "short": "YYYY/MM/DD",
    "long": "YYYY年M月D日",
    "withTime": "YYYY/MM/DD HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "这是 VynaEMR 演示环境 — 请勿输入真实患者信息（PHI）。"
  },
  "network": {
    "offline": "您已离线。临床数据可能无法保存。"
  },
  "permissionDenied": {
    "title": "访问被拒绝",
    "body": "您没有权限{{action}}。",
    "genericBody": "您没有权限查看此资源。",
    "requiredPermission": "所需权限：{{name}}",
    "contactAdmin": "如果您认为这是错误，请联系您的系统管理员。",
    "requiresPermissionCode": "需要权限：{{code}}",
    "requiresLabel": "需要 {{label}}",
    "requiresLabelWithRoles": "需要 {{label}}（持有者：{{roles}}）",
    "insufficient": "权限不足"
  },
  "skipToContent": "跳至主要内容",
  "openMenu": "打开菜单",
  "topBar": {
    "searchPlaceholder": "搜索患者（MRN、姓名、ID）...",
    "recentPatients": "最近患者",
    "searching": "搜索中...",
    "noPatientsFound": "未找到患者。按 Enter 键搜索。",
    "notifications": "通知",
    "selectFacility": "选择机构",
    "allFacilities": "所有机构",
    "facilityLabel": "机构 {{id}}",
    "activeDepartment": "当前科室",
    "selectDepartment": "选择工作科室",
    "noDepartmentSelected": "请选择科室",
    "departmentLabel": "科室 {{id}}",
    "departmentSwitchFailed": "切换失败"
  },
  "theme": {
    "toggle": "切换主题",
    "light": "浅色",
    "dark": "深色",
    "system": "系统",
    "current": "主题：{{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "运行正常",
  "footerHealthIssue": "连接异常",
  "dobLabel": "出生日期 {{date}}",
  "pagination": {
    "previous": "上一页",
    "next": "下一页",
    "pageOf": "第 {{current}} 页，共 {{total}} 页",
    "showing": "显示第 {{from}} 至 {{to}} 项，共 {{total}} 项",
    "loadMore": "加载更多"
  },
  "table": {
    "empty": "暂无数据",
    "loading": "加载中..."
  },
  "cdsAlert": {
    "severity": {
      "info": "信息",
      "warning": "警告",
      "critical": "严重"
    },
    "overridden": "已覆盖",
    "acknowledged": "已确认",
    "justificationPlaceholder": "请输入理由说明...",
    "submit": "提交",
    "acknowledge": "确认",
    "override": "覆盖",
    "regionAria": "临床决策支持（CDS）警报",
    "acknowledgeFailed": "无法记录确认 — 未保存。请重试。",
    "overrideFailed": "无法记录覆盖 — 未保存。请重试。",
    "addressedCount_one": "已处理 {{count}} 项",
    "addressedCount_other": "已处理 {{count}} 项"
  },
  "components": {
    "printButton": {
      "defaultLabel": "打印"
    },
    "codeSearch": {
      "searchPlaceholder": "搜索代码...",
      "clearAriaLabel": "清除选择",
      "noCodesFound": "未找到代码"
    },
    "demographicPicker": {
      "addPlaceholder": "添加…",
      "loading": "加载中…",
      "noneRecorded": "未记录",
      "removeAriaLabel": "删除{{value}}",
      "unavailable": "值列表不可用",
      "unavailableHint": "无法加载值列表。现有值保持不变，仍将保存。",
      "uncodedBadge": "未编码",
      "uncodedTitle": "在启用编码值之前记录。可以删除，但无法重新添加。"
    }
  },
  "pages": {
    "accessDenied": {
      "title": "拒绝访问",
      "httpStatus": "HTTP 403",
      "body": "您没有权限查看此页面。",
      "attemptedLabel": "尝试访问：",
      "requiredPermissionLabel": "所需权限：",
      "typicallyHeldByLabel": "通常拥有此权限的角色：",
      "signedInAs": "登录用户：",
      "contactAdminHelp": "如果您认为这是错误，请联系系统管理员或科室主任以申请所需角色。",
      "goBack": "返回",
      "dashboard": "仪表盘",
      "contact": "联系"
    },
    "notificationInbox": {
      "title": "通知",
      "markAllRead": "全部标记为已读",
      "loading": "正在加载通知…",
      "errorState": "通知加载失败。",
      "emptyState": "未找到通知。",
      "ariaFilterStatus": "按状态筛选",
      "ariaFilterPriority": "按优先级筛选",
      "ariaFilterType": "按类型筛选",
      "filterStatus": {
        "all": "全部",
        "unread": "未读",
        "read": "已读"
      },
      "filterPriority": {
        "allLabel": "全部优先级",
        "critical": "危急",
        "high": "高",
        "normal": "一般",
        "low": "低"
      },
      "filterType": {
        "allLabel": "全部类型"
      },
      "notificationType": {
        "criticalResult": "危急值结果",
        "orderUpdate": "医嘱更新",
        "appointmentReminder": "预约提醒",
        "systemAlert": "系统提醒",
        "cdsAlert": "临床决策提醒",
        "result": "检验结果",
        "handoffAssigned": "交接"
      },
      "toasts": {
        "allMarkedRead": "所有通知已标记为已读",
        "markAllReadFailed": "全部标记为已读失败",
        "markReadFailed": "通知标记为已读失败"
      }
    },
    "entityResolver": {
      "invalidId": "链接无效。",
      "notFound": "未找到，或您无权访问。"
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "实时更新不可用",
    "body": "在连接恢复之前，新的结果和提醒将不会自动送达。",
    "authBody": "您的会话已过期。请重新登录以恢复实时更新。",
    "retry": "重试",
    "login": "登录"
  }
}
